export const NEWSLETTER_FORM_URL = 'https://readdy.ai/api/form/d9s8vo6e3oq4jqumu78g';